import { LDFlagSet, useFlags } from "launchdarkly-react-client-sdk";
import { useAuth } from "../auth/identity-auth0-context";
import { LDFlagKey } from "../launchdarkly/flags";

interface CanShowItemProps {
  requiredPermission: string;
  ldFlag?: LDFlagKey;
}

const isFlagEnabled = (flags: LDFlagSet, flag?: LDFlagKey) =>
  flag ? Boolean(flags[flag]) : true;

const useCanShowItem = () => {
  const flags = useFlags();
  const { hasAccess } = useAuth();

  const canShowItem = ({ requiredPermission, ldFlag }: CanShowItemProps) => {
    return hasAccess(requiredPermission) && isFlagEnabled(flags, ldFlag);
  };

  return canShowItem;
};

export default useCanShowItem;
